import React from 'react';

type ListProps = {
  item: {
    format: string;
  };
  children: [];
};

export default function List({ item, children }: ListProps) {
  if (item.format === 'ordered') {
    return <ol>{children}</ol>;
  }
  if (item.format === 'unordered') {
    return <ul>{children}</ul>;
  }

  return <>{children}</>;
}
